/* ----- Releasit: enviar external_id (teléfono) ----- */
(function () {
  // Escucha el evento que dispara Releasit al enviar el formulario
  document.addEventListener('releasit_cod_form_order_submitted', function (e) {
    // 1. Número de teléfono limpio (solo dígitos)
    var phone = (e.detail.order.phone || '').replace(/\D/g, '');
    if (!phone) return;

    // 2. Lo usamos como external_id Y como event_id
    var eid = phone;

    // 3. Re-disparamos Purchase con external_id
    fbq('track', 'Purchase', {
      currency: 'PEN',
      value: 0,
      ph: phone,               // already hashed automáticamente
      external_id: eid,
      eventID: eid             // → servirá para deduplicar
    });
  });
})();
